<template>
	<aside>
        <div>
            <compFormQuery v-if="type=='query'" :formdata="getBase" :value="formData" :labelWidth="150"></compFormQuery>
            <compFormEdit v-else class="margin-15 clearfix" ref="baseform" :formdata="getBase" v-model="formData" :labelWidth="150" />
        </div>
		<vButtonGroup class="text-right margin-top-15" v-if="type !== 'query'">
			<vButton theme="primary" @click="submit">保存</vButton>
			<vButton @click="close">取消</vButton>
		</vButtonGroup>
		<vLoading size="large" fix :loading="loading"></vLoading>
	</aside>
</template>
<script>
import { HttpCustomCostPackage, HttpCustomPackageDetail, HttpGetWarehouseByOrg } from '@/service/tasks';
import { mapGetters } from 'vuex';
import mixin from '../mixin';
export default {
	mixins: [mixin],
    props: [ 'querytype', 'activeids', ],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import('@components/templates/formedit'),
	},
	data() {
		return {
            id: this.$route.query.id || this.activeids,
            type: this.$route.params.type || this.querytype,
			loading: false,
			formData: {},
            warehouseList1: [],
		};
	},
	created() {
        this.update();
	},
	computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getCusproductList', 'getAdminTransferWarehouse']),
		getBase() {
			return [
				{
					label: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
					key: 'orgId',
					tag: 'vSelect',
					options: this.getBillcusorgList,
					props: {
                        filterable: true,
                    },
                    span: 24,
                    on:{
                        'on-change':(val)=>{
                            if(val){
                                this.findWarehouse(val);
                                this.formData.warehouse = [];
                            }
                        }
                    },
				},
                {
                    label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                    key: 'warehouse',
                    tag: 'vSelect',
                    options: this.warehouseList1 ,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    span: 24,
                },
                {
                    label: "包仓日期",
                    key: 'packageDate',
                    tag: 'vDatepicker',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd~yyyy-mm-dd',
                        confirm: false,
                    },
                    span: 24,
                },
                {
                    label: "包仓总体积（CBM）",
                    key: 'volume',
					tag: 'vInputNumber',
                    props: {
						min: 0,
					},
                    span: 24,
                },
			]
		},
	},
	methods: {
        async findWarehouse(org){
            this.loading = true;
            await HttpGetWarehouseByOrg({customerOrgId: org}).then(res=>{
                this.loading = false
                this.warehouseList1 = res.data.map(item=>{
                    return {value: item.code, label: `${item.code}(${item.title})`, attach: item}
                })
            },err=>{
                this.loading = false
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true,
                });
            })
        },
		update() {
            if(this.type == 'add') return
			this.loading = true
            HttpCustomPackageDetail({
                id:this.id
            }).then(res=>{
                this.loading = false;
                this.formData = res.data;
                this.formData.warehouse = res.data.packItemCustomerEntities.map(item=>{
                    return item.orgWarehouseCode
                });
                this.formData.packageDate = res.data.packStartAt + '~' + res.data.packEndAt;
                this.findWarehouse(res.data.orgId)
            },err=>{
                this.loading = false;
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
		},
		close() {
			this.$emit('on-close')
		},
		async submit() {
            const valid = await this.$refs.baseform.validate();
			if (!valid) return;
            if(this.formData.volume <= 0){
                this.$Message.error({
                    content: '包仓总体积不小于0！',
                    duration: 30,
                    closable: true,
                });
                return;
            }
            let packItemCustomerEntities = this.formData.warehouse.map(item=>{
                let warehouse = this.warehouseList1.filter( obj => obj.value === item)[0];
                return {
                    orgWarehouseId: warehouse.attach.id,
                    orgWarehouseCode: warehouse.value
                }
            })
            let packStartAt = this.formData.packageDate.split('~')[0]
            let packEndAt = this.formData.packageDate.split('~')[1]
			this.loading = true
			HttpCustomCostPackage({id: this.id, hostOrgId: global.SYSID, orgId: this.formData.orgId, packItemCustomerEntities, packStartAt, packEndAt, volume: this.formData.volume}).then(res => {
                this.$Message.success({
                    content: res.message,
                    duration: 30,
                    closable: true,
                });
				this.close();
				this.$emit('on-update');
			}, err => {
				this.loading = false;
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true,
                });
			})
		}
	}
};
</script>
